module.exports = __webpack_public_path__ + "static/media/transactions.b31265f7.svg";